import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../../contexts/AuthContext";
import { usePermission } from "../../contexts/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import { performLogout } from "../../utils/logoutHandler";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { useTranslation } from 'react-i18next';
import useGapIntelligenceEnabled from "../ComplianceOperations/GapIntelligence/useGapIntelligenceEnabled";
import { hasGapFrameworkCapability } from "../../config/gapFrameworks";
import "./sidebar.css";
// Removed sidebar-specific CSS to revert to global App.css
const API_URL = process.env.REACT_APP_API_URL;
console.log("API_URL =>", API_URL); // <-- Add this for debugging

const CaraUserSidebar = () => {
  const { t } = useTranslation('sidebar');
  const location = useLocation();
  const { tprmUser } = useAuth();
  const [isHovered, setIsHovered] = useState(false);

  const { caraUser } = useAuth();
  const gapIntelligenceEnabled = useGapIntelligenceEnabled(caraUser?.admin_id);
  const { can } = usePermission();

  const { caraAdmin } = useAuth();

  const auditChecklistObj = caraUser?.capabilities?.find(
    (item) => typeof item === "object" && item.Audit_checklist
  );

  const auditChecklist = auditChecklistObj?.Audit_checklist;

  console.log("Audit checklist =>", auditChecklist);

  console.log("Audit checklist capabilities =>", auditChecklist);

  console.log("user Package =>", caraUser?.package);

  //for Assessment dashboard for TPRM user or Cara Admin
  const dashboardLink =
    tprmUser?.user_type === "14"
      ? "/tprm_admin_dashboard"
      : "/assessment_dashboard";

  // const cara_roi_quantifier = tprmUser?.user_type === "14" ? "/upgrade" : "/cara_roi_quantifier";

  // Check if the current route is related to RBI framework
  const isRbiFrameworkActive =
    location.pathname === "/view_rbi_cara" ||
    location.pathname === "/rbi_csf_framework" ||
    location.pathname === "/instructions" ||
    location.pathname === "/ucb_contact" ||
    location.pathname === "/circuler_ref";

  useEffect(() => {
    const $ = window.$;

    $(".sidebar")
      .off("click.treeview")
      .on("click.treeview", ".has-treeview > a", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation(); // Prevent double trigger
        e.stopPropagation(); // Also stop bubbling

        const parent = $(this).parent();
        const submenu = parent.find("> .nav-treeview");

        const isOpen = parent.hasClass("menu-open");

        if (isOpen) {
          // Close the current
          parent.removeClass("menu-open menu-is-opening");
          submenu.slideUp();
        } else {
          // Close all sibling treeviews
          parent.siblings(".has-treeview.menu-open")
            .removeClass("menu-open menu-is-opening")
            .find("> .nav-treeview")
            .slideUp();

          // Open current
          parent.addClass("menu-open menu-is-opening");
          submenu.slideDown();
        }
      });

    return () => {
      $(".sidebar").off("click.treeview");
    };
  }, []);


  const handleLogout = async () => {
    try {
      // Get username and role from localStorage (more reliable than context)
      const username = localStorage.getItem("username");
      const role = localStorage.getItem("role");

      // CRITICAL: Validate username before logout
      if (!username) {
        console.error(
          "No username found in localStorage! Cannot perform logout properly."
        );

        // Force logout even without username
        alert("Session data missing. Logging out...");
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/cara_login";
        return;
      }

      // Use centralized logout handler for immediate cross-tab synchronization
      // Pass role from localStorage instead of context
      await performLogout(role, role);

      // Show success message after API call
      toast.success("User logged out successfully");
    } catch (error) {
      console.error("Logout Error:", error);
      toast.error(`Logout Error: ${error.message}`);

      // Even on error, force logout
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/login";
    }
  };
  const [user, setUser] = useState(null); // Store user data

  useEffect(() => {
    // Fetch logged-in user details
    axios
      .get(`${API_URL}api/userr-detail/`, { withCredentials: true }) // Adjust API URL as needed
      .then((response) => {
        setUser(response.data); // Store user details in state
      })
      .catch((error) => {
        console.error("Error fetching user details:", error);
      });
  }, []);

  // State to track the active menu item
  const [activeItem, setActiveItem] = useState("");

  // Function to handle menu item click
  const handleMenuClick = (item) => {
    setActiveItem(item);
  };

  // Search functionality
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const $ = window.$;
    // Search functionality - filter menu items
    const searchValue = searchTerm.toLowerCase().trim();
    if (searchValue) {
      // Find and scroll to matching menu items (including those in collapsed submenus)
      const menuItems = document.querySelectorAll('.nav-link p, .nav-link');
      let foundMatch = false;
      let firstMatch = null;

      menuItems.forEach((item) => {
        const text = item.textContent?.toLowerCase() || '';
        if (text.includes(searchValue)) {
          const navItem = item.closest('.nav-item');
          if (navItem) {
            // Check if this item is inside a collapsed submenu
            let parentTreeview = navItem.closest('.has-treeview');
            while (parentTreeview && !parentTreeview.classList.contains('menu-open')) {
              // Use jQuery to expand the parent menu
              const $parent = $(parentTreeview);
              const $submenu = $parent.find('> .nav-treeview');

              // Close all sibling menus first
              $parent.siblings('.has-treeview.menu-open')
                .removeClass('menu-open menu-is-opening')
                .find('> .nav-treeview')
                .css('display', 'none');

              // Open the current menu
              $parent.addClass('menu-open menu-is-opening');
              $submenu.css('display', 'block');

              // Move up to parent treeview if nested
              parentTreeview = parentTreeview.parentElement.closest('.has-treeview');
            }

            // Store first match for scrolling
            if (!foundMatch) {
              firstMatch = navItem;
            }

            foundMatch = true;
          }
        }
      });

      if (foundMatch && firstMatch) {
        // Scroll to the first match after menu expansion
        setTimeout(() => {
          const sidebar = document.querySelector('.sidebar');
          if (sidebar && firstMatch) {
            const itemTop = firstMatch.offsetTop;
            const sidebarScrollTop = sidebar.scrollTop;
            const sidebarHeight = sidebar.clientHeight;

            // Calculate scroll position to center the item
            const scrollTo = itemTop - (sidebarHeight / 2) + (firstMatch.offsetHeight / 2);

            // Smooth scroll the sidebar container instead of using scrollIntoView
            sidebar.scrollTo({
              top: scrollTo,
              behavior: 'smooth'
            });

            // Highlight the matching item
            firstMatch.classList.add('highlight-search');
            setTimeout(() => {
              firstMatch.classList.remove('highlight-search');
            }, 2000);
          }
        }, 150); // Wait for menu expansion animation
      } else if (!foundMatch) {
        // Optional: Show a message if no matches found
        console.log('No matches found');
      }
    }
  };
  return (
    <div
      className="cara-sidebar-root"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Styles moved to sidebar.css */}
      {/* Main Sidebar Container */}
      <aside
        id="mainSidebar"
        className="main-sidebar sidebar-dark-primary elevation-4"
        data-bs-theme="dark"
      >
        {/* Brand Logo Section */}
        <Link
          to={
            (caraUser?.role_name || "").toLowerCase().trim() === "internal auditor"
              ? "/internal_auditor_dashboard"
              : (caraUser?.role_name || "").toLowerCase().trim() === "external auditor"
                ? "/external_auditor_dashboard"
                : "/assessment_dashboard"
          }
          className="d-flex align-items-center m-3"
        >
          <img
            src={
              isHovered
                ? "../img/cyberinsurify_logo.png"
                : "../img/cyberinsurify-logo-small.png"
            }
            alt="CyberInsurify Logo"
            className={`logo-small brand-image ${isHovered ? "hovered" : ""}`}
          />
          <span className="brand-text font-weight-light">
            <img
              src={
                isHovered
                  ? "../img/cyberinsurify_logo.png"
                  : "../img/cyberinsurify_logo.png"
              }
              alt="CyberInsurify Logo"
              className="brand-logo ml-4"
            />
          </span>
        </Link>
        {/* Brand Name */}
        <h6 className="fw-300 ml-3 fs-5 ">
          {caraUser?.user_type === "16" ? "Auditor" : "CARA 2.0"}
        </h6>

        {/* Sidebar */}
        <div
          className="sidebar sidebar-font"
        >
          {/* Sidebar user panel (optional) */}

          {/* SidebarSearch Form */}

          {/* Sidebar Menu */}
          <nav className="mt-2">
            {/* Search Bar Section */}
            <form onSubmit={handleSearch} className="input-group mb-3 sidebar-search">
              <input
                type="text"
                className="form-control search-input"
                placeholder={t('menu.search')}
                aria-label="Sidebar search"
                value={searchTerm}
                onChange={handleSearchChange}
              />
              <div className="input-group-append">
                <button
                  className="btn btn-outline-secondary square-btn"
                  type="submit"
                  aria-label="Search"
                >
                  <i
                    className="fas fa-search"
                  ></i>
                </button>

              </div>
            </form>
            <ul
              className="nav nav-pills nav-sidebar flex-column text-left"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              {/* Add icons to the links using the .nav-icon class
         with font-awesome or any other icon font library */}

              {/* Command Center */}
              {caraUser?.capabilities?.includes("Command Center") && (
                <li className="nav-item">
                  <Link to="/command_center" className="nav-link">
                    <img
                      src="../img/dashboard-icon.png"
                      alt="Command Center Icon"
                      className="icon-style me-2"
                    />
                    <p>{t('menu.commandCenter')}</p>
                  </Link>
                </li>
              )}

              {(caraUser?.capabilities?.includes("Dashboard") ||
                caraUser?.capabilities?.includes("NIST CSF 2.0 Assessment") ||
                caraUser?.capabilities?.includes("NIST CSF 1.0 Assessment") ||
                caraUser?.capabilities?.includes(
                  "NIST Ransomware Assessment"
                ) ||
                caraUser?.capabilities?.includes("NIST AI RMF Assessment") ||
                caraUser?.capabilities?.includes("ISO 27001 Assessment") ||
                caraUser?.capabilities?.includes("CIS V8.1 Assessment") ||
                caraUser?.capabilities?.includes("RBI CSF Assessment") ||
                caraUser?.capabilities?.includes("TPRM Dashboard") ||
                caraUser?.capabilities?.includes("CRQ Dashboard") ||
                caraUser?.capabilities?.includes("Risk Dashboard") ||
                caraUser?.capabilities?.includes(
                  "Resilience Posture Dashboard"
                ) ||
                caraUser?.capabilities?.includes("Audits Dashboard")) && (
                  <li className="nav-item has-treeview">
                    <Link to="#" className="nav-link">
                      <img
                        src="../img/dashboard-icon.png"
                        alt="Dashboard Icon"
                        className="icon-style me-2"
                      />                      <p>{t('menu.dashboard')}
                        <i className="right fas fa-angle-left" />
                      </p>
                    </Link>


                    <ul className="nav nav-treeview">
                      {(caraUser?.capabilities?.includes("Assessments Dashboard") || caraUser?.capabilities?.some((cap) =>
                        [
                          "NIST CSF 2.0 Assessment",
                          "NIST CSF 1.0 Assessment",
                          "NIST Ransomware Assessment",
                          "NIST AI RMF Assessment",
                          "ISO 27001 Assessment",
                          "CIS V8.1 Assessment",
                          "RBI CSF Assessment",
                        ].includes(cap)
                      )) && (
                          <li className="nav-item">
                            <Link to={dashboardLink} className="nav-link">
                              <img
                                src="../img/sub-icon.png"
                                className="sub-icon me-2"
                              />
                              <p>{t('menu.dashboard.assessments')}</p>
                            </Link>
                          </li>
                        )}

                      {caraUser?.capabilities?.includes("TPRM Dashboard") && (
                        <li className="nav-item">
                          <Link
                            to="/tprm_dashboard"
                            className="nav-link"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />
                            <p>{t('menu.dashboard.tprm')}</p>
                          </Link>
                        </li>
                      )}
                      {caraUser?.capabilities?.includes("Risk Dashboard") && (
                        <li className="nav-item">
                          <Link to="/risk_dashboard" className="nav-link">
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />
                            <p>{t('menu.dashboard.risk')}</p>
                          </Link>
                        </li>
                      )}
                      {([1, 2, 13, 16, 17].includes(Number(caraUser?.user_type)) || [1, 2, 13, 16, 17].includes(Number(tprmUser?.user_type)) || caraUser?.capabilities?.includes("Report Builder")) && (
                        <li className="nav-item">
                          <Link to="/risk_report_builder" className="nav-link">
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />
                            <p>{t('menu.dashboard.reportBuilder')}</p>
                          </Link>
                        </li>
                      )}

                      {caraUser?.capabilities?.includes("CRQ Dashboard") && (
                        <li className="nav-item">
                          <Link
                            to="/crq_dashboard"
                            className="nav-link d-flex flex-column align-items-start position-relative"
                          >
                            <span
                              className="badge bg-primary text-light mb-1 badge-beta"
                            >
                              Beta
                            </span>
                            <div className="d-flex align-items-center">
                              <img
                                src="../img/sub-icon.png"
                                className="sub-icon me-2"
                              />
                              <p className="mb-0">{t('menu.dashboard.crq')}</p>
                            </div>
                          </Link>
                        </li>
                      )}

                      {caraUser?.capabilities?.includes(
                        "Resilience Posture Dashboard"
                      ) && (
                          <li className="nav-item">
                            <Link to="/crp_dashboard" className="nav-link">
                              <img
                                src="../img/sub-icon.png"
                                className="sub-icon me-2"
                              />
                              <p>{t('menu.dashboard.crp')}</p>
                            </Link>
                          </li>
                        )}

                      {/* Bug_Id_241: shown to every role granted the Audit
                          Dashboard permission. External Auditors get their own
                          dashboard; everyone else (Internal Auditor, Manager, ...)
                          gets the internal one, which the backend also opens
                          to any non-external role holding dashboards.audits. */}
                      {caraUser?.capabilities?.includes("Audits Dashboard") && (
                        <li className="nav-item">
                          <Link
                            to={
                              (caraUser?.role_name || "").toLowerCase().trim() ===
                                "external auditor"
                                ? "/external_auditor_dashboard"
                                : "/internal_auditor_dashboard"
                            }
                            className="nav-link"
                          >
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />
                            <p>{t('menu.dashboard.audits')}</p>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </li>
                )}

              {/*  OffSec - each item needs the capability its page's API
                  checks, with the same fallbacks as the backend */}
              {(caraUser?.capabilities?.includes("OffSec Service Requests") ||
                caraUser?.capabilities?.includes("OffSec Engagements") ||
                caraUser?.capabilities?.includes("OffSec Findings") ||
                caraUser?.capabilities?.includes("OffSec Revalidation") ||
                caraUser?.capabilities?.includes("OffSec Reports")) && (
                  <li className="nav-item has-treeview">
                    <Link to="#" className="nav-link">
                      <img
                        src="../img/checklist-icon.svg"
                        alt="OffSec Icon"
                        className="icon-style me-2"
                      />
                      <p>
                        OffSec
                        <i className="right fas fa-angle-left" />
                      </p>
                    </Link>
                    <ul className="nav nav-treeview">
                      {caraUser?.capabilities?.includes("OffSec Engagements") && (
                        <li className="nav-item">
                          <Link to="/offsec_dashboard" className="nav-link">
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />
                            <p>Dashboard</p>
                          </Link>
                        </li>
                      )}
                      {caraUser?.capabilities?.includes("OffSec Service Requests") && (
                        <li className="nav-item">
                          <Link to="/offsec_service_requests" className="nav-link">
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />
                            <p>Service Requests</p>
                          </Link>
                        </li>
                      )}
                      {caraUser?.capabilities?.includes("OffSec Engagements") && (
                        <li className="nav-item">
                          <Link to="/offsec_engagements" className="nav-link">
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />
                            <p>Engagements</p>
                          </Link>
                        </li>
                      )}
                      {caraUser?.capabilities?.includes("OffSec Findings") && (
                        <li className="nav-item">
                          <Link to="/offsec_findings" className="nav-link">
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />
                            <p>Findings and Remediation</p>
                          </Link>
                        </li>
                      )}
                      {(caraUser?.capabilities?.includes("OffSec Revalidation") ||
                        caraUser?.capabilities?.includes("OffSec Findings")) && (
                          <li className="nav-item">
                            <Link to="/offsec_revalidation" className="nav-link">
                              <img
                                src="../img/sub-icon.png"
                                className="sub-icon me-2"
                              />
                              <p>Revalidation</p>
                            </Link>
                          </li>
                        )}
                      {(caraUser?.capabilities?.includes("OffSec Reports") ||
                        caraUser?.capabilities?.includes("OffSec Engagements")) && (
                          <li className="nav-item">
                            <Link to="/offsec_reports" className="nav-link">
                              <img
                                src="../img/sub-icon.png"
                                className="sub-icon me-2"
                              />
                              <p>Reports</p>
                            </Link>
                          </li>
                        )}
                      {/* <li className="nav-item">
                    <Link to="/offsec_administration" className="nav-link">
                      <img
                        src="../img/sub-icon.png"
                        className="sub-icon me-2"
                      />
                      <p>Administration</p>
                    </Link>
                  </li> */}
                    </ul>
                  </li>
                )}

              {/* CSF Assessment - Conditionally render based on RBI framework route */}
              {isRbiFrameworkActive && (
                <li className="nav-item has-treeview ">
                  <Link to="#" className="nav-link">
                    <img
                      src="../img/risk-management.png"
                      alt="risk-management Icon"
                      className="icon-style me-2"
                    />
                    <p>
                      {t('menu.csfAssessment')}
                      <i className="right fas fa-angle-left" />
                    </p>
                  </Link>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <Link to="/instructions" className="nav-link">
                        <img
                          src="../img/sub-icon.png"
                          className="sub-icon me-2"
                        />
                        <p>{t('menu.compliance.frameworks')}</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/ucb_contact" className="nav-link">
                        <img
                          src="../img/sub-icon.png"
                          className="sub-icon me-2"
                        />
                        <p>Bank Contact</p>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/circuler_ref" className="nav-link">
                        <img
                          src="../img/sub-icon.png"
                          className="sub-icon me-2"
                        />
                        <p>Circular-ref</p>
                      </Link>
                    </li>
                  </ul>
                </li>
              )}
              {/* Show Compliance Operations if user_type is NOT 14 */}
              {(caraUser?.capabilities?.includes("CO NIST CSF 2.0 Assessment") ||
                caraUser?.capabilities?.includes("CO NIST CSF 1.0 Assessment") ||
                caraUser?.capabilities?.includes("CO NIST Ransomware Assessment") ||
                caraUser?.capabilities?.includes("CO NIST AI RMF Assessment") ||
                caraUser?.capabilities?.includes("CO ISO 27001 Assessment") ||
                caraUser?.capabilities?.includes("CO CIS V8.1 Assessment") ||
                caraUser?.capabilities?.includes("CO RBI CSF Assessment") ||
                caraUser?.capabilities?.includes("Frameworks & Standards") ||
                caraUser?.capabilities?.includes("Asset Management") ||
                caraUser?.capabilities?.includes("Assets Management") ||
                caraUser?.capabilities?.includes("Process Management") ||
                caraUser?.capabilities?.includes("Asset Mapping") ||
                caraUser?.capabilities?.includes("Compliance Tracker") ||
                caraUser?.capabilities?.includes("Progress Tracker") ||
                caraUser?.capabilities?.includes("Evidence Tracker") ||
                caraUser?.capabilities?.includes("Smart Map")) && (
                  <li className="nav-item has-treeview">
                    <Link to="#" className="nav-link">
                      <img
                        src="../img/risk-management.png"
                        alt="risk-management Icon"
                        className="icon-style me-2"
                      />
                      <p>
                        {t('menu.compliance')}
                        <i className="right fas fa-angle-left" />
                      </p>
                    </Link>

                    <ul className="nav nav-treeview">
                      {(caraUser?.capabilities?.includes("Frameworks & Standards") ||
                        caraUser?.capabilities?.includes("CO NIST CSF 2.0 Assessment") ||
                        caraUser?.capabilities?.includes("CO NIST CSF 1.0 Assessment") ||
                        caraUser?.capabilities?.includes("CO NIST Ransomware Assessment") ||
                        caraUser?.capabilities?.includes("CO NIST AI RMF Assessment") ||
                        caraUser?.capabilities?.includes("CO ISO 27001 Assessment") ||
                        caraUser?.capabilities?.includes("CO CIS V8.1 Assessment") ||
                        caraUser?.capabilities?.includes("CO RBI CSF Assessment")) && (
                          <li className="nav-item">
                            <Link
                              to="/framework_and_standards"
                              className="nav-link"
                            >
                              <img
                                src="../img/sub-icon.png"
                                className="sub-icon me-2"
                              />
                              <p>{t('menu.compliance.frameworks')}</p>
                            </Link>
                          </li>
                        )}
                      {/* Archived Frameworks */}
                      {/* <li className="nav-item">
                        <Link
                          to="/archived_frameworks"
                          className="nav-link"
                        >
                          <img
                            src="../img/sub-icon.png"
                            className="sub-icon me-2"
                          />
                          <p>Archived Frameworks</p>
                        </Link>
                      </li> */}

                      {(caraUser?.capabilities?.includes("Asset Management") ||
                        caraUser?.capabilities?.includes("Assets Management") ||
                        caraUser?.capabilities?.includes("Process Management") ||
                        caraUser?.capabilities?.includes("Asset Mapping")) && (
                          <li className="nav-item has-treeview">
                            <Link to="#" className="nav-link">
                              <img
                                src="../img/sub-icon.png"
                                className="sub-icon me-2"
                              />
                              <p>
                                {t('menu.compliance.assets')}
                                <i className="right fas fa-angle-left closer-arrow ms-2" />
                              </p>
                            </Link>
                            <ul className="nav nav-treeview">
                              {(caraUser?.capabilities?.includes("Asset Management") || caraUser?.capabilities?.includes("Assets Management")) && (
                                <li className="nav-item">
                                  <Link to="/asset_management" className="nav-link">
                                    <img
                                      src="../img/sub-icon.png"
                                      className="sub-icon me-2"
                                    />
                                    <p>{t('menu.assets.assets')}</p>
                                  </Link>
                                </li>
                              )}
                              {caraUser?.capabilities?.includes("Process Management") && (
                                <li className="nav-item">
                                  <Link to="/process_management" className="nav-link">
                                    <img
                                      src="../img/sub-icon.png"
                                      className="sub-icon me-2"
                                    />
                                    <p>{t('menu.compliance.process')}</p>
                                  </Link>
                                </li>
                              )}
                              {caraUser?.capabilities?.includes("Asset Mapping") && (
                                <li className="nav-item">
                                  <Link to="/asset_mapping" className="nav-link">
                                    <img
                                      src="../img/sub-icon.png"
                                      className="sub-icon me-2"
                                    />
                                    <p>{t('menu.compliance.mapping')}</p>
                                  </Link>
                                </li>
                              )}
                            </ul>
                          </li>
                        )}

                      {/* {caraUser?.capabilities?.includes("Compliance Tracker") && (
        <li className="nav-item">
          <Link to="/compliance_tracker" className="nav-link">
            <img src="../img/sub-icon.png" style={{ height: 14, width: 14 }} className='me-2' />
            <p>Compliance Tracker</p>
          </Link>
        </li>
      )} */}

                      {caraUser?.capabilities?.includes("Progress Tracker") && (
                        <li className="nav-item">
                          <Link to="/progress_tracker" className="nav-link">
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />
                            <p>{t('menu.compliance.progress')}</p>
                          </Link>
                        </li>
                      )}

                      {caraUser?.capabilities?.includes("Evidence Tracker") && (
                        <li className="nav-item">
                          <Link to="/evidence_tracker" className="nav-link">
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />
                            <p>{t('menu.compliance.evidence')}</p>
                          </Link>
                        </li>
                      )}

                      {gapIntelligenceEnabled && hasGapFrameworkCapability(caraUser?.capabilities) &&
                        can('gap_mgmt.register', 'read') && (
                          <li className="nav-item">
                            <Link to="/gap_register" className="nav-link">
                              <img
                                src="../img/sub-icon.png"
                                className="sub-icon me-2"
                                alt=""
                              />
                              <p>{t('menu.compliance.gapRegister')}</p>
                            </Link>
                          </li>
                        )}

                      {gapIntelligenceEnabled &&
                        (hasGapFrameworkCapability(caraUser?.capabilities) ||
                          caraUser?.capabilities?.includes("Risk Assessments")) &&
                        can('action_tasks.tracker', 'read') && (
                          <li className="nav-item">
                            <Link to="/action_tracker" className="nav-link">
                              <img
                                src="../img/sub-icon.png"
                                className="sub-icon me-2"
                                alt=""
                              />
                              <p>{t('menu.compliance.actionTracker')}</p>
                            </Link>
                          </li>
                        )}

                      {caraUser?.user_type === "16" && (
                        <li className="nav-item">
                          <Link to="/questionnaire" className="nav-link">
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />                            <p>{t('menu.compliance.assessment')}</p>
                          </Link>
                        </li>
                      )}

                      {caraUser?.capabilities?.includes("Smart Map") && (
                        <li className="nav-item">
                          <Link to="/smart_map_framework" className="nav-link">
                            <span
                              className="badge bg-primary text-light mb-1 badge-beta"
                            >
                              Beta
                            </span>
                            <div className="d-flex align-items-center">
                              <img
                                src="../img/sub-icon.png"
                                className="sub-icon me-2"
                              />
                              <p>{t('menu.compliance.smartMap')}</p>
                            </div>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </li>
                )}
              {/*  Documentation */}
              {(caraUser?.capabilities?.includes("Documentation Generator") ||
                caraUser?.capabilities?.includes("Document Vault") ||
                caraUser?.capabilities?.includes("Policy Library")) && (
                  <li className="nav-item has-treeview">
                    <Link to="#" className="nav-link">
                      <img
                        src="../img/documentation-icon.svg"
                        className="icon-style me-2"
                      />
                      <p>
                        {t('menu.documentation')}
                        <i className="fas fa-angle-left right" />
                      </p>
                    </Link>
                    <ul className="nav nav-treeview">
                      {caraUser?.capabilities?.includes("Documentation Generator") && (
                        <li className="nav-item">
                          <Link to="/documentation" className="nav-link">
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />
                            <p>{t('menu.documentation.generator')}</p>
                          </Link>
                        </li>
                      )}
                      {caraUser?.capabilities?.includes("Document Vault") && (
                        <li className="nav-item">
                          <Link to="/document_vault" className="nav-link">
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />
                            <p>{t('menu.documentation.vault')}</p>
                          </Link>
                        </li>
                      )}
                      {caraUser?.capabilities?.includes("Policy Library") && (
                        <li className="nav-item">
                          <Link to="/policy_library" className="nav-link">
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />
                            <p>Policy Library</p>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </li>
                )}

              {/*  Regulatory Library */}
              {(caraUser?.capabilities?.includes("Regulatory Library") ||
                caraUser?.capabilities?.includes("Penalties")) && (
                  <li className="nav-item has-treeview">
                    <Link to="#" className="nav-link">
                      <img
                        src="../img/documentation-icon.svg"
                        className="icon-style me-2"
                      />
                      <p>
                        {t('menu.regulatoryLibrary')}
                        <i className="fas fa-angle-left right" />
                      </p>
                    </Link>
                    <ul className="nav nav-treeview">
                      {caraUser?.capabilities?.includes("Regulatory Library") && (
                        <li className="nav-item">
                          <Link to="/regulatory_library" className="nav-link">
                            <span
                              className="badge bg-primary text-light mb-1 badge-beta"
                            >
                              Beta
                            </span>
                            <div className="d-flex align-items-center">
                              <img
                                src="../img/sub-icon.png"
                                className="sub-icon me-2"
                              />
                              <p>{t('menu.regulatoryLibrary.regulatory')}</p>
                            </div>
                          </Link>
                        </li>
                      )}
                      {caraUser?.capabilities?.includes("Penalties") && (
                        <li className="nav-item">
                          <Link to="/regulatory_library/penalties" className="nav-link">
                            <span
                              className="badge bg-primary text-light mb-1 badge-beta"
                            >
                              Beta
                            </span>
                            <div className="d-flex align-items-center">
                              <img
                                src="../img/sub-icon.png"
                                className="sub-icon me-2"
                              />
                              <p>{t('menu.regulatoryLibrary.penalties')}</p>
                            </div>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </li>
                )}
              {/* Risk Management */}
              {(caraUser?.capabilities?.includes("CARA ROI Quantifier") ||
                caraUser?.capabilities?.includes("Enterprise Risk Register") ||
                caraUser?.capabilities?.includes("Risk Register Tracker") ||
                caraUser?.capabilities?.includes("Risk Assessments") ||
                caraUser?.capabilities?.includes(
                  "Risk Assessments Tracker"
                )) && (
                  <li className="nav-item has-treeview">
                    <Link to="#" className="nav-link">
                      <img
                        src="../img/risk-icon.png"
                        alt="Risk Icon"
                        className="icon-style me-2"
                      />
                      <p>
                        {t('menu.riskManagement')}
                        <i className="fas fa-angle-left right" />
                      </p>
                    </Link>
                    <ul className="nav nav-treeview">

                      {caraUser?.capabilities?.includes(
                        "CARA ROI Quantifier"
                      ) && (
                          <li className="nav-item">
                            <Link to="/cara_roi_quantifier" className="nav-link">
                              <span
                                className="badge bg-primary text-light mb-1 badge-beta"
                              >
                                Beta
                              </span>
                              <div className="d-flex align-items-center">
                                <img
                                  src="../img/sub-icon.png"
                                  className="sub-icon me-2"
                                />
                                <p>{t('menu.risk.roi')}</p>
                              </div>
                            </Link>
                          </li>
                        )}

                      {caraUser?.capabilities?.includes(
                        "Enterprise Risk Register"
                      ) && (
                          <li className="nav-item">
                            <Link
                              to={
                                tprmUser?.user_type === "14"
                                  ? "/upgrade"
                                  : "/risk_register"
                              }
                              className="nav-link"
                            >
                              <img
                                src="../img/sub-icon.png"
                                className="sub-icon me-2"
                              />
                              <p>{t('menu.riskManagement.enterpriseRegister', { defaultValue: 'Enterprise Risk Register' })}</p>
                            </Link>
                          </li>
                        )}

                      {caraUser?.capabilities?.includes(
                        "Risk Register Tracker"
                      ) && (
                          <li className="nav-item">
                            <Link to="/risk_register_tracker" className="nav-link">
                              <img
                                src="../img/sub-icon.png"
                                className="sub-icon me-2"
                              />
                              <p>{t('menu.riskManagement.tracker')}</p>
                            </Link>
                          </li>
                        )}



                      {caraUser?.capabilities?.includes("Risk Assessments") && (
                        <li className="nav-item">
                          <Link to="/risk_assessment" className="nav-link">
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />
                            <p>{t('menu.riskManagement.assessment')}</p>
                          </Link>
                        </li>
                      )}

                      {gapIntelligenceEnabled && caraUser?.capabilities?.includes("Risk Assessments") &&
                        can('framework_risk.register', 'read') && (
                          <li className="nav-item">
                            <Link to="/framework_risk_register" className="nav-link">
                              <img
                                src="../img/sub-icon.png"
                                className="sub-icon me-2"
                                alt=""
                              />
                              <p>{t('menu.riskManagement.frameworkRisks')}</p>
                            </Link>
                          </li>
                        )}

                      {caraUser?.capabilities?.includes(
                        "Risk Assessments Tracker"
                      ) && (
                          <li className="nav-item">
                            <Link to="/risk_assesment_tracker" className="nav-link">
                              <img
                                src="../img/sub-icon.png"
                                className="sub-icon me-2"
                              />
                              <p>{t('menu.risk.assessmentTracker')}</p>
                            </Link>
                          </li>
                        )}
                    </ul>
                  </li>
                )}

              {/* Audit Management */}
              {(caraUser?.capabilities?.includes("Manage Audits View") ||
                caraUser?.capabilities?.includes("Assets Management") ||
                caraUser?.capabilities?.includes("Audit Document") ||
                caraUser?.capabilities?.includes("Audit Tracker") ||
                // A user granted only checklists still needs the Audit
                // Management group to render, or its checklist link is hidden.
                ["Audit Checklist", "GDPR", "Data Protection Act", "ISO 27001",
                  "Service Organization Control (SOC) 2", "Cara Compliance and Risk Assessment",
                  "Cara Ai Security", "Inside Threat Defense", "FATF Mutual Evaluation"
                ].some((cap) => caraUser?.capabilities?.includes(cap))) && (
                  <li className="nav-item has-treeview">
                    <Link to=" " className="nav-link">
                      <span className="sidebar-icons">
                        <img
                          src="../img/audit-icon.svg "
                          className="icon-style me-2"
                        />
                      </span>
                      <p>
                        {t('menu.audit')}
                        <i className="fas fa-angle-left right" />
                      </p>
                    </Link>
                    <ul className="nav nav-treeview">
                      <li className="nav-item">
                        {caraUser?.capabilities?.includes(
                          "Manage Audits View"
                        ) && (
                            <Link
                              to={
                                tprmUser?.user_type === "14"
                                  ? "/upgrade"
                                  : "/manage_audit"
                              }
                              className="nav-link"
                            >
                              <img
                                src="../img/sub-icon.png "
                                className="sub-icon me-2"
                              />
                              <p>{t('menu.audit.manage')}</p>
                            </Link>
                          )}
                      </li>
                      <li className="nav-item">
                        {(caraUser?.capabilities?.includes("GDPR") ||
                          caraUser?.capabilities?.includes("Data Protection Act") ||
                          caraUser?.capabilities?.includes("ISO 27001") ||
                          caraUser?.capabilities?.includes("Service Organization Control (SOC) 2") ||
                          caraUser?.capabilities?.includes("Cara Compliance and Risk Assessment") ||
                          caraUser?.capabilities?.includes("Cara Ai Security") ||
                          caraUser?.capabilities?.includes("Inside Threat Defense") ||
                          caraUser?.capabilities?.includes("FATF Mutual Evaluation")) && (
                            <Link
                              to={
                                tprmUser?.user_type === "14"
                                  ? "/upgrade"
                                  : "/audit_checklist"
                              }
                              className="nav-link"
                            >
                              <img
                                src="../img/sub-icon.png "
                                className="sub-icon me-2"
                              />
                              <p>{t('menu.audit.checklist')}</p>
                            </Link>
                          )}
                      </li>
                      <li className="nav-item">
                        {caraUser?.capabilities?.includes("Audit Document") && (
                          <Link
                            to={
                              tprmUser?.user_type === "14"
                                ? "/upgrade"
                                : "/audit_documents"
                            }
                            className="nav-link"
                          >
                            <img
                              src="../img/sub-icon.png "
                              className="sub-icon me-2"
                            />
                            <p>{t('menu.audit.documents')}</p>
                          </Link>
                        )}
                      </li>

                      <li className="nav-item">
                        {caraUser?.capabilities?.includes("Audit Tracker") && (
                          <Link to="/audit_tracker" className="nav-link">
                            <img
                              src="../img/sub-icon.png "
                              className="sub-icon me-2"
                            />
                            <p>{t('menu.audit.tracker')}</p>
                          </Link>
                        )}
                      </li>
                    </ul>
                  </li>
                )}

              {/*  Third Party Management */}
              {(caraUser?.capabilities?.includes("CyberFirst") ||
                caraUser?.capabilities?.includes("CyberSolutions") ||
                caraUser?.capabilities?.includes("Third Party Users") ||
                caraUser?.capabilities?.includes("TPRM Audit Trail") ||
                caraUser?.capabilities?.includes("TPRM Tracker") ||
                caraUser?.capabilities?.includes("TPRM Support Requests")) && (
                  <li className="nav-item has-treeview">
                    <Link to="#" className="nav-link">
                      <span className="sidebar-icons">
                        <img
                          src="../img/third-party-icon.png"
                          className="icon-style me-2"
                        />
                      </span>
                      <p>
                        {t('menu.tprmMgmt', { defaultValue: 'Third Party Risk Mgmt' })}
                        <i className="right fas fa-angle-left" />
                      </p>
                    </Link>
                    <ul className="nav nav-treeview">
                      {caraUser?.capabilities?.includes("TPRM Support Requests") && (
                        <li className="nav-item">
                          <Link to="/tprm_support_requests" className="nav-link">
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />
                            <p>Support Requests</p>
                          </Link>
                        </li>
                      )}
                      {(caraUser?.capabilities?.includes("CyberFirst") ||
                        caraUser?.capabilities?.includes("CyberSolutions") ||
                        caraUser?.capabilities?.includes(
                          "Create your own Questionnaire"
                        )) && (
                          <li className="nav-item">
                            <Link to="/questionnaire" className="nav-link">
                              <img
                                src="../img/sub-icon.png"
                                className="sub-icon me-2"
                              />
                              <p>{t('menu.tprm.questionnaire')}</p>
                            </Link>
                          </li>
                        )}

                      {caraUser?.capabilities?.includes("TPRM Tracker") && (
                        <li className="nav-item">
                          <Link to="/tprm_tracker" className="nav-link">
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />
                            <p>{t('menu.tprm.tracker')}</p>
                          </Link>
                        </li>
                      )}

                      {caraUser?.capabilities?.includes("Third Party Users") && (
                        <li className="nav-item">
                          <Link to="/third_party_users" className="nav-link">
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />
                            <p>{t('menu.tprm.users')}</p>
                          </Link>
                        </li>
                      )}

                      {caraUser?.capabilities?.includes("TPRM Audit Trail") && (
                        <li className="nav-item">
                          <Link to="/audit_trail_users" className="nav-link">
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />
                            <p>{t('menu.tprm.auditTrail', { defaultValue: 'Audit Trail' })}</p>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </li>
                )}

              {/*  User Management */}
              {(caraUser?.capabilities?.includes("Roles Management") ||
                caraUser?.capabilities?.includes("Department Management") ||
                caraUser?.capabilities?.includes("Business Units") ||
                caraUser?.capabilities?.includes("Locations") ||
                caraUser?.capabilities?.includes("My Users") ||
                caraUser?.capabilities?.includes("Audit Trail")) && (
                  <li className="nav-item has-treeview">
                    <Link to="#" className="nav-link">
                      <span className="sidebar-icons">
                        <img
                          src="../img/user-icon.svg"
                          className="icon-style me-2"
                        />
                      </span>
                      <p>
                        {t('menu.userManagement')}
                        <i className="right fas fa-angle-left" />
                      </p>
                    </Link>

                    <ul className="nav nav-treeview">
                      {caraUser?.capabilities?.includes("Roles Management") && (
                        <li className="nav-item">
                          <Link to="/role_management" className="nav-link">
                            <img
                              src="../img/sub-icon.png "
                              className="sub-icon me-2"
                            />
                            <p>{t('menu.userManagement.roles')}</p>
                          </Link>
                        </li>
                      )}

                      {caraUser?.capabilities?.includes(
                        "Department Management"
                      ) && (
                          <li className="nav-item">
                            <Link to="/department_management" className="nav-link">
                              <img
                                src="../img/sub-icon.png "
                                className="sub-icon me-2"
                              />
                              <p>{t('menu.userManagement.departments')}</p>
                            </Link>
                          </li>
                        )}
                      {caraUser?.capabilities?.includes("My Users") && (
                        <li className="nav-item">
                          <Link to="/my_users" className="nav-link">
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />
                            <p>{t('menu.userManagement.users')}</p>
                          </Link>
                        </li>
                      )}

                      {caraUser?.capabilities?.includes("Audit Trail") && (
                        <li className="nav-item">
                          <Link to="/audit_trail_user" className="nav-link">
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />                            <p>{t('menu.audit.trail')}</p>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </li>
                )}

              {/*  Virtual Risk Manager */}
              {(caraUser?.capabilities?.includes("Contact VRM") ||
                caraUser?.capabilities?.includes("My Request") ||
                caraUser?.capabilities?.includes("Connect with VRM") ||
                caraUser?.capabilities?.includes("Admin VRM Recommendations")) && (
                  <li className="nav-item has-treeview">
                    <Link to="#" className="nav-link">
                      <img
                        src="../img/virtual-risk-icon.svg"
                        className="icon-style me-2"
                      />
                      <p>
                        {t('menu.vrm')}
                        <i className="right fas fa-angle-left" />
                      </p>
                    </Link>
                    <ul className="nav nav-treeview">
                      {caraUser?.capabilities?.includes("Contact VRM") && (
                        <li className="nav-item">
                          <Link to="/contact_vrm" className="nav-link">
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />
                            <p>{t('menu.vrm.contact')}</p>
                          </Link>
                        </li>
                      )}

                      {caraUser?.capabilities?.includes("My Request") && (
                        <li className="nav-item">
                          <Link to="/my_request" className="nav-link">
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />
                            <p>{t('menu.vrm.request')}</p>
                          </Link>
                        </li>
                      )}

                      {caraUser?.capabilities?.includes("Admin VRM Recommendations") && (
                        <li className="nav-item">
                          <Link to="/admin_vrm_recommendations" className="nav-link">
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />
                            <p>VRM Recommendations</p>
                          </Link>
                        </li>
                      )}

                      <li className="nav-item">
                        <Link to="/vrm_tracker" className="nav-link">
                          <img
                            src="../img/sub-icon.png"
                            className="sub-icon me-2"
                          />
                          <p>VRM Tracker</p>
                        </Link>
                      </li>

                      {caraUser?.capabilities?.includes("Connect with VRM") && (
                        <li className="nav-item">
                          <Link to="/connect_with_vrm" className="nav-link">
                            <img
                              src="../img/sub-icon.png"
                              className="sub-icon me-2"
                            />
                            <p>{t('menu.vrm.meeting')}</p>
                          </Link>
                        </li>
                      )}
                    </ul>
                  </li>
                )}

              {/*  Cyber Resilience Posture */}
              {caraUser?.capabilities?.includes("Cyber Resilience Posture") && (
                <li className="nav-item">
                  <Link
                    to="/cyber_resilience_posture"
                    className="nav-link"
                  >
                    <img
                      src="../img/cyber-icon.svg"
                      className="icon-style me-2"
                    />
                    <p>{t('menu.cyberResilience')}</p>
                  </Link>
                </li>
              )}



              {/*  Ask the Expert */}
              {caraUser?.capabilities?.includes("Chat Support") && (
                <li className="nav-item">
                  <Link
                    to="/ask_the_expert"
                    className="nav-link"
                  >
                    <span className="sidebar-icons">
                      <img
                        src="../img/ask-expert-icon.png"
                        className="icon-style me-2"
                      />
                    </span>
                    <p>{t('menu.support.expert')}</p>
                  </Link>
                </li>
              )}

              {/*  Email Support */}
              {/* <li className="nav-item">
                <Link to="/email_support" className="nav-link" style={{ color: 'white' }}>
                  <span className="sidebar-icons">
                    <img src="../img/envelope-icon.svg" style={{ height: 20, width: 20 }} className="icon-style me-2" />
                  </span>
                  <p>Email Support</p>
                </Link>
              </li> */}

              {/*  Feedback and Suggestions */}
              {caraUser?.capabilities?.includes("Feedback & Suggestions") && (
                <li className="nav-item has-treeview">
                  <Link to="#" className="nav-link">
                    <span className="sidebar-icons">
                      <img
                        src="../img/feedback-icon.png"
                        className="icon-style me-2"
                      />
                    </span>
                    <p>
                      {t('menu.support.feedback')}
                      <i className="right fas fa-angle-left" />
                    </p>
                  </Link>
                  <ul className="nav nav-treeview">
                    <li className="nav-item">
                      <Link to="/submit_feedback" className="nav-link">
                        <img
                          src="/img/sub-icon.png"
                          className="sub-icon me-2"
                        />
                        <p>{t('menu.feedback.submit')}</p>
                      </Link>
                    </li>

                    {caraUser?.user_type !== "16" && (
                      <li className="nav-item">
                        <Link to="/my_feedback" className="nav-link">
                          <img
                            src="../img/sub-icon.png"
                            className="sub-icon me-2"
                          />
                          <p>{t('menu.feedback.my')}</p>
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
              )}

              {/*  Resources */}
              <li className="nav-item has-treeview">
                <Link to="#" className="nav-link">
                  <img
                    src="/img/resources-icon.svg"
                    className="icon-style me-2"
                  />
                  <p>
                    {t('menu.resources')}
                    <i className="right fas fa-angle-left" />
                  </p>
                </Link>
                <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <Link
                      to="https://caragrc.com/blog/"
                      className="nav-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="../img/sub-icon.png"
                        className="sub-icon me-2"
                      />
                      <p>{t('menu.resources.blog')}</p>
                    </Link>
                  </li>
                </ul>
              </li>



              {/*  My Settings */}
              <li className="nav-item has-treeview">
                <Link to="#" className="nav-link">
                  <span className="sidebar-icons">
                    <img
                      src="../img/settings-icon.svg"
                      className="icon-style me-2"
                    />
                  </span>
                  <p>
                    {t('menu.settings')}
                    <i className="right fas fa-angle-left" />
                  </p>
                </Link>
                <ul className="nav nav-treeview">
                  {caraUser?.user_type !== "16" && caraUser?.capabilities?.includes("Audit Trail") && (
                    <li className="nav-item">
                      <Link to="/audit_trails" className="nav-link">
                        <img
                          src="../img/sub-icon.png"
                          className="sub-icon me-2"
                        />
                        <p>{t('menu.settings.auditTrails')}</p>
                      </Link>
                    </li>
                  )}
                  <li className="nav-item">
                    <Link to="/privacy" className="nav-link">
                      <img
                        src="../img/sub-icon.png"
                        className="sub-icon me-2"
                      />
                      <p>{t('menu.settings.privacy')}</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/profile" className="nav-link">
                      <img
                        src="../img/sub-icon.png"
                        className="sub-icon me-2"
                      />
                      <p>{t('menu.settings.profile')}</p>
                    </Link>
                  </li>
                </ul>
              </li>

              {/* Logout Section */}
              <li className="nav-item mb-3">
                <button
                  className="nav-link d-flex align-items-center logout-btn"
                  onClick={() => {
                    Swal.fire({
                      title: t('menu.logoutConfirmTitle', { defaultValue: 'Are you sure?' }),
                      text: t('menu.logoutConfirmText', { defaultValue: 'You will be logged out of your session!' }),
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#3085d6",
                      cancelButtonColor: "#d33",
                      confirmButtonText: t('menu.logoutConfirmBtn', { defaultValue: 'Yes, logout!' }),
                      background: "#fff",
                      color: "#333",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        handleLogout();
                      }
                    });
                  }}
                >
                  <span className="sidebar-icons">
                    <img
                      src="../img/logout-icon.png"
                      className="icon-style me-2"
                      alt="logout-icon"
                    />
                  </span>
                  <p className="mb-0">
                    {t('menu.logout')}
                    {user && (
                      <span className="logout-username">
                        {user.first_name} {user.last_name}
                      </span>
                    )}
                  </p>
                </button>
              </li>
            </ul>
          </nav>
          {/* /.sidebar-menu */}
        </div>
        {/* /.sidebar */}
      </aside>

    </div>
  );
};

export default CaraUserSidebar;
